<div class="mini-details-container br-tile" [ngClass]="{ 'expanded': expandMiniItem() }"
    (click)="preventDefault($event)" (mousemove)="preventDefault($event)">
    <div class="mini-details">
        <div class="poster flex items-center justify-center" (click)="onPlayClick($event)"
            [ngClass]="{'disable-events': isPlayDisabled(), 'has-delete-button': deleteShow()}"
            [transcodeImage]="thumbnail()"
            [alwaysReload]="true">
            @if (restricted()) {
            <content-rating-lock />
            }
            @if(enableAutoplayExtras){
            <div class="video-container" [ngClass]="{ 'playing': previewVideoPlaying() }">
                <ng-container #playerContainer></ng-container>
            </div>

            @if(previewVideoPlaying()){
            <rounded-icon-button class="mute-button" (onClick)="toggleMute($event)"
                [imgSrc]="skinning.getImage(playerMuted() ? 'icon_sound_off' : 'icon_sound_on')"></rounded-icon-button>
            }

            }
            @if(deleteShow()){
            <rounded-icon-button data-testid="mini-details_delete" class="z-1 delete-button"
                [analytics]="AnalyticEvent.WatchLaterRemoved"
                (onClick)="deleteItem($event)" [imgSrc]="skinning.getImage('icon_delete')"></rounded-icon-button>
            }

            @if(!isPlayDisabled() && !previewVideoPlaying()){
            <rounded-icon-button [imgSrc]="skinning.getImage('icon_play')"></rounded-icon-button>
            }

            @if (showBadge()) {
            <badge data-testid="mini-details_badge" [class.badge-hidden]="previewVideoPlaying()"
                [style.--badge-offset.px]="badgeOffset()"
                [badge]="item()?.badge"
                [variant]="BadgeVariant.MiniDetails"
                [availabilityStartTime]="item()?.availabilityStartTime"
                [availabilityEndTime]="item()?.availabilityEndTime"
                [hasUpcomingEnabled]="item()?.hasUpcomingEnabled ?? false"
                [hasOutgoingEnabled]="item()?.hasOutgoingEnabled ?? false"
                [showAutomaticBadge]="showAutomaticBadge()">
            </badge>
            }

        </div>
        <div class="info flex flex-col p-4 fs-6" (click)="openDetails()">
            <div class="flex justify-between">
                <div class="title fw-semibold line-clamp-2 mb-2">
                    {{ restricted() ? ('common.protected_content_title' | transloco) : item()?.title }}
                </div>

                <div class="info-button-place">
                    @if (item()?.referenceId) {
                    <rounded-icon-button (click)="openDetails()" [imgSrc]="skinning.getImage('icon_more')"
                        class="info-button"></rounded-icon-button>
                    }
                </div>
            </div>
            <!-- Same order as the details header: date, time, duration, rating, year, categories. -->
            <div class="metadata flex items-center fs-6 mb-2" data-testid="mini-details_metadata">
                @if (airDate()) {
                <div>
                    <img src="{{ skinning.getImage('icon_date') }}">
                    {{ airDate() }}
                </div>
                }
                @if (runningTime()) {
                <div>
                    <img src="{{ skinning.getImage('icon_time') }}">
                    {{ runningTime() }}
                </div>
                }
                @if (durationLabel()) {
                <div data-testid="mini-details_duration">
                    <img src="{{ skinning.getImage('icon_duration') }}">
                    {{ durationLabel() }}
                </div>
                }
                @if (item()?.contentRating) {
                <div data-testid="mini-details_content-rating">
                    <img src="{{ skinning.getImage('icon_pg') }}">
                    {{item().contentRating }}
                </div>
                }
                @if (item()?.productionYear) {
                <div data-testid="mini-details_year">{{ item().productionYear }}</div>
                }
                @if (item()?.categories?.length) {
                <div class="categories line-clamp-1">
                    {{ item().categories.join(', ') }}
                </div>
                }
                <!-- dummy for reservation info-button place -->
                <div class="info-button-place-metadata"></div>
            </div>

            <div class="description fs-6 font-light line-clamp-3 mb-2">
                {{item()?.description }} &nbsp;
            </div>
        </div>
        @if (item()?.referenceId) {
        <div class="timeline" [style.width.%]="timelinePercentage()"></div>
        }
    </div>
</div>
